// React をインポート
import React from 'react';
// リマインド依頼ダイアログをインポート
import { SelectReminderUserModal } from './SelectReminderUserModal';
// プロパティインターフェースを定義
export interface SelectReminderUserModalLayoutProps {
  // リマインドID
  reminderId: string;
  // ダイアログの開閉状態保持 (true：開く、false：閉じる)
  isModalOpen: boolean;
  // ダイアログクローズ時動作。openをfalseに変更
  onClose: () => void;
}
// リマインドユーザーを選択するダイアログ
export const SelectReminderUserModalLayout: React.FC<SelectReminderUserModalLayoutProps> = (props) => {
  // パラメータ
  const { reminderId, isModalOpen, onClose } = props;

  return (
    <SelectReminderUserModal
      // リマインドID
      reminderId={reminderId}
      // ダイアログの開閉状態保持 (true：開く、false：閉じる)
      open={isModalOpen}
      // ダイアログクローズ時動作。openをfalseに変更
      onClose={onClose}
    />
  );
};
